import React from "react";
import "../../styles/app/RatesSection.css";
import { useTranslation } from "react-i18next";

const RatesSection: React.FC = () => {
  const { t } = useTranslation();
  const stats = t("ratesSection.stats", { returnObjects: true }) as { id: string; percentage: number; title: string; description: string }[];

  return (
    <section className="rates-section">
      <div className="rates-grid">
        {stats.map((stat) => (
          <div key={stat.id} className="rates-card">
            <div
              className="rates-circular-progress"
              style={{ "--percent": stat.percentage } as React.CSSProperties}
            >
              <span className="rates-progress-value">{stat.percentage}%</span>
            </div>
            <h3 className="rates-card-title">{stat.title}</h3>
            <p className="rates-card-description">{stat.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RatesSection;
